<template>
  <div class="d-flex">
    <button
      type="button"
      class="btn btn-danger btn-circle"
      @click="emitToParent(quantity - 1)"
      :disabled="quantity === 1"
    >
      <i class="fa fa-minus"></i>
    </button>
    <p class="m-0 mx-3 lead">{{quantity}}</p>
    <button type="button" :disabled="quantity >= saleLimit" class="btn btn-primary btn-circle" @click="emitToParent(quantity + 1)">
      <i class="fa fa-plus"></i>
    </button>
  </div>
</template>

<script>
export default {
  props: {
    quantity: Number,
    saleLimit: {
      type: Number,
      default: +Infinity
    }
  },
  methods: {
    emitToParent(newValue) {
      this.$emit("update", newValue);
    }
  }
};
</script>

<style lang="scss" scoped>
.btn-circle {
  width: 30px;
  height: 30px;
  padding: 6px 0px;
  border-radius: 15px;
  text-align: center;
  font-size: 12px;
  line-height: 1.42857;
}
</style>
